import moment from 'moment'

export default class KLineEntity {
  constructor({ max, time, min, open, close, volume }, timeFactor = 1000) {
    this.Date = moment(time * timeFactor).format('MM-DD HH:mm')
    this.Open = open
    this.High = max
    this.Low = min
    this.Close = close
    this.Volume = volume
    this.MA5Price = 0
    this.MA10Price = 0
    this.MA20Price = 0
    this.MA30Price = 0
    this.MA60Price = 0
    this.dea = 0
    this.dif = 0
    this.macd = 0
    this.k = 0
    this.d = 0
    this.j = 0
    this.r = 0
    this.rsi = 0
    this.up = 0
    this.mb = 0
    this.dn = 0
    this.MA5Volume = 0
    this.MA10Volume = 0
    // this.ratio = 0
    // this.timestamp = ''
  }

  getDate() {
    return this.Date
  }

  getOpenPrice() {
    return this.Open
  }

  getHighPrice() {
    return this.High
  }

  getLowPrice() {
    return this.Low
  }

  getClosePrice() {
    return this.Close
  }

  getMA5Price() {
    return this.MA5Price
  }

  getMA10Price() {
    return this.MA10Price
  }

  getMA20Price() {
    return this.MA20Price
  }

  getMA60Price() {
    return this.MA60Price
  }

  getDea() {
    return this.dea
  }

  getDif() {
    return this.dif
  }

  getMacd() {
    return this.macd
  }

  getK() {
    return this.k
  }

  getD() {
    return this.d
  }

  getJ() {
    return this.j
  }

  getR() {
    return this.r
  }

  getRsi() {
    return this.rsi
  }

  getUp() {
    return this.up
  }

  getMb() {
    return this.mb
  }

  getDn() {
    return this.dn
  }

  getVolume() {
    return this.Volume
  }

  getMA5Volume() {
    return this.MA5Volume
  }

  getMA10Volume() {
    return this.MA10Volume
  }

  // getTimestamp() {
  //   return this.timestamp
  // }

  // setTimestamp(timestamp) {
  //   this.timestamp = timestamp
  // }
}
